<script>
export default {
  /**
   * The item's label - gets rendered within a `strong` tag
   *
   * @type {string}
   */
  props: {
    label: {
      type: String,
      required: true,
    },
  },
};
</script>

<template>
  <li>
    <strong class="gl-font-bold">{{ label }}</strong>
    <slot></slot>
  </li>
</template>
